import { clearSessionPreservingPrintSettings } from "../utils/orderPrintSettings";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RedirectLoadingModal from "../components/RedirectLoadingModal";
import "./OrderLoginPage.css";

const APP_LOGIN_FAILURE_DELAY_MS = 2000;
const APP_LOGIN_MIN_LOADING_MS = 2000;

const waitForMinimumAppLoginLoading = (startedAt) => {
  const remainingTime = Math.max(
    0,
    APP_LOGIN_MIN_LOADING_MS - (Date.now() - startedAt)
  );

  return new Promise((resolve) => window.setTimeout(resolve, remainingTime));
};

const handleAuthenticatedUser = (data, setError) => {
  if (!data.user || !Object.prototype.hasOwnProperty.call(data.user, "LoaiCH")) {
    setError(
      "Không tìm thấy thông tin loại cửa hàng (LoaiCH) để điều hướng."
    );
    return false;
  }

  const { user } = data;

  localStorage.setItem("token", data.token);
  localStorage.setItem("LoaiCH", user.LoaiCH);
  localStorage.setItem("TenCuaHang", user.TenCuaHang);
  localStorage.setItem("IDCH", user.IDCH);
  localStorage.setItem("MaNV", user.MaNV);
  localStorage.setItem("TenUser", user.TenUser);
  localStorage.setItem("MaPB", user.MaPB);
  localStorage.setItem("MaChucVu", user.MaChucVu);
  localStorage.setItem("stk", user.STKNganHang);
  localStorage.setItem("bank_name", user.NganHang);
  localStorage.setItem("Address", user.DiaChi);
  localStorage.setItem("Phone", user.SoDienThoai);
  localStorage.setItem(
    "IpBanhNgot",
    typeof user.IpBanhNgot === "string" ? user.IpBanhNgot.trim() : ""
  );
  localStorage.setItem(
    "IpMayTinh",
    typeof user.IpMayTinh === "string" ? user.IpMayTinh.trim() : ""
  );
  localStorage.setItem(
    "IpThuNgan",
    typeof user.IpThuNgan === "string" ? user.IpMayIn.trim() : ""
  );
  if (Array.isArray(user.IpBep)) {
    localStorage.setItem(
      "IpBep",
      typeof user.IpBep[0] === "string" ? user.IpBep[0].trim() : ""
    );
  } else {
    localStorage.setItem(
      "IpBep",
      typeof user.IpBep === "string" ? user.IpBep.trim() : ""
    );
  }
  localStorage.setItem(
    "LamTron",
    typeof user.LamTron === "string" ? user.LamTron.trim() : ""
  );

  if (
    user.MaPB === 2 ||
    user.MaPB === 3 ||
    user.MaPB === 4 ||
    user.MaPB === 145 ||
    user.MaPB === 170 ||
    user.MaPB === 187 ||
    user.MaPB === 250 ||
    user.MaPB === 16 ||
    user.MaPB === 321
  ) {
    localStorage.setItem("isAdmin", true);
  } else if (user.MaPB === 142) {
    localStorage.setItem("HCM_ADMIN", true);
  } else {
    localStorage.setItem("isBakery", true);
  }

  const loaiCH = user.LoaiCH;
  if (
    user.MaPB === 80 ||
    user.MaPB === 170 ||
    user.MaPB === 187 ||
    user.MaPB === 250
  ) {
    return "/nhap-hang";
  } else if (
    user.MaPB === 3 ||
    user.MaPB === 4 ||
    user.MaPB === 145 ||
    user.MaPB === 16 ||
    user.MaPB === 321
  ) {
    return "/admin";
  } else if (loaiCH === 99 && localStorage.getItem("HCM_ADMIN") !== "true") {
    return "/order/dongtien";
  } else if (loaiCH === 0) {
    return "/order/bonpas";
  } else if (loaiCH === 2 || loaiCH === "Admin") {
    return "/order/dongtien";
  } else if (loaiCH === 3 || localStorage.getItem("HCM_ADMIN") === "true") {
    return "/order/hcm";
  } else {
    setError(
      "Loại tài khoản không được hỗ trợ hoặc không có quyền truy cập."
    );
    localStorage.removeItem("token");
    localStorage.removeItem("LoaiCH");
    localStorage.removeItem("TenCuaHang");
    localStorage.removeItem("IDCH");
    localStorage.removeItem("MaNV");
    localStorage.removeItem("TenUser");
    return null;
  }
};

function OrderLoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [error, setError] = useState("");
  const [appLoginStatus, setAppLoginStatus] = useState(() => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get("emp") &&
      searchParams.get("t") &&
      searchParams.get("sign")
      ? "loading"
      : "idle";
  });
  const isAppLoginLoading = appLoginStatus === "loading";
  const appLoginAttemptedRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    const authError = localStorage.getItem("error");
    if (authError === "unauthorized") {
      toast.error("Bạn không thể truy cập cửa hàng này");
      localStorage.removeItem("error");
    }
  }, []);

  useEffect(() => {
    if (appLoginAttemptedRef.current) {
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const emp = searchParams.get("emp");
    const t = searchParams.get("t");
    const sign = searchParams.get("sign");
    const hasAppLoginParams = emp !== null || t !== null || sign !== null;

    if (!hasAppLoginParams) {
      return;
    }

    appLoginAttemptedRef.current = true;
    window.history.replaceState(
      window.history.state,
      document.title,
      `${window.location.pathname}${window.location.hash}`
    );

    if (!emp || !t || !sign) {
      setError("Liên kết đăng nhập không hợp lệ hoặc thiếu thông tin.");
      return;
    }

    clearSessionPreservingPrintSettings();

    const loginFromDoticomApp = async () => {
      const loadingStartedAt = Date.now();
      setError("");
      setAppLoginStatus("loading");

      const timestamp = Number(t);
      if (!/^\d+$/.test(t) || !Number.isSafeInteger(timestamp)) {
        await waitForMinimumAppLoginLoading(loadingStartedAt);
        setError("Timestamp trong liên kết đăng nhập không hợp lệ.");
        setAppLoginStatus("failed");
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/check-doticom`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ emp, t: timestamp, sign }),
          }
        );
        const data = await response.json();

        if (!response.ok) {
          await waitForMinimumAppLoginLoading(loadingStartedAt);
          setError(
            data.message || "Liên kết đăng nhập không hợp lệ hoặc đã hết hạn."
          );
          setAppLoginStatus("failed");
          return;
        }

        const redirectPath = handleAuthenticatedUser(data, setError);
        await waitForMinimumAppLoginLoading(loadingStartedAt);

        if (!redirectPath) {
          clearSessionPreservingPrintSettings();
          setAppLoginStatus("failed");
          return;
        }

        navigate(redirectPath);
      } catch (err) {
        console.error("Doticom app login API error:", err);
        clearSessionPreservingPrintSettings();
        await waitForMinimumAppLoginLoading(loadingStartedAt);
        setError("Không thể kết nối đến máy chủ. Vui lòng thử lại sau.");
        setAppLoginStatus("failed");
      }
    };

    loginFromDoticomApp();
  }, [navigate]);

  useEffect(() => {
    if (appLoginStatus !== "failed") {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setError("");
      setAppLoginStatus("idle");
    }, APP_LOGIN_FAILURE_DELAY_MS);

    return () => window.clearTimeout(timeoutId);
  }, [appLoginStatus]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); // Clear previous errors

    if (isAppLoginLoading) {
      return;
    }

    if (!username || !password) {
      setError("Vui lòng nhập tên đăng nhập và mật khẩu.");
      return;
    }

    try {
      if (username === "admin") {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/admin-login`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ username: username, password: password }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          setError(data.message || "Đã xảy ra lỗi. Vui lòng thử lại.");
          return;
        }

        // Assuming login is successful
        console.log("Login successful api admin-login:", data);
        // Store token if needed, e.g., localStorage.setItem('token', data.token);

        if (data.user && data.user.hasOwnProperty("LoaiCH")) {
          // Store user information in local storage
          localStorage.setItem("token", data.token); // Also store the token
          localStorage.setItem("LoaiCH", data.user.LoaiCH);
          localStorage.setItem("TenCuaHang", data.user.TenCuaHang);
          localStorage.setItem("IDCH", data.user.IDCH);
          localStorage.setItem("MaNV", data.user.MaNV);
          localStorage.setItem("TenUser", data.user.TenUser);
          localStorage.setItem("LoaiCH", data.user.LoaiCH);
          localStorage.setItem("MaPB", data.user.MaPB);
           localStorage.setItem("MaChucVu", data.user.MaChucVu);
          localStorage.setItem(
            "IpBanhNgot",
            typeof data.user.IpBanhNgot === "string"
              ? data.user.IpBanhNgot.trim()
              : ""
          );
          localStorage.setItem(
            "IpMayTinh",
            typeof data.user.IpMayTinh === "string"
              ? data.user.IpMayTinh.trim()
              : ""
          );
          localStorage.setItem(
            "IpThuNgan",
            typeof data.user.IpThuNgan === "string"
              ? data.user.IpThuNgan.trim()
              : ""
          );
          if (Array.isArray(data.user.IpBep)) {
            localStorage.setItem(
              "IpBep",
              typeof data.user.IpBep[0] === "string"
                ? data.user.IpBep[0].trim()
                : ""
            );
          } else {
            localStorage.setItem(
              "IpBep",
              typeof data.user.IpBep === "string" ? data.user.IpBep.trim() : ""
            );
          }
          localStorage.setItem(
            "LamTron",
            typeof data.user.LamTron === "string"
              ? data.user.LamTron.trim()
              : ""
          );
          const loaiCH = data.user.LoaiCH;
          if (loaiCH === 0) {
            navigate("/order/bonpas");
          } else if (loaiCH === 2 || loaiCH === "Admin" ) {
            navigate("/order/dongtien");
          } else if (loaiCH === 3 ) {
            navigate("/order/hcm");
          } else {
            // Handle other LoaiCH values or if user is not authorized for any specific known page
            setError(
              "Loại tài khoản không được hỗ trợ hoặc không có quyền truy cập."
            );
            // Potentially log out or clear token and user info if stored
            localStorage.removeItem("token");
            localStorage.removeItem("LoaiCH");
            localStorage.removeItem("TenCuaHang");
            localStorage.removeItem("IDCH");
            localStorage.removeItem("MaNV");
            localStorage.removeItem("TenUser");
          }
        } else {
          setError(
            "Không tìm thấy thông tin loại cửa hàng (LoaiCH) để điều hướng."
          );
        }
      } else {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ TenUser: username, Password: password }),
        });

        const data = await response.json();

        if (!response.ok) {
          setError(data.message || "Đã xảy ra lỗi. Vui lòng thử lại.");
          return;
        }

        console.log("Login successful user role:", data);
        const redirectPath = handleAuthenticatedUser(data, setError);
        if (redirectPath) {
          navigate(redirectPath);
        }
      }
    } catch (err) {
      console.error("Login API error:", err);
      setError("Không thể kết nối đến máy chủ. Vui lòng thử lại sau.");
    }
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <RedirectLoadingModal status={appLoginStatus} />
      <div className="order-login-page">
        <section className="login-glass-card">
          <div className="login-glass-header">
            {/* simple lock icon + title */}
            <svg
              className="lock"
              width="36"
              height="36"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                fill="currentColor"
                d="M12 2a4 4 0 00-4 4v3H6a2 2 0 00-2 2v7a2 2 0 002 2h12a2 2 0 002-2v-7a2 2 0 00-2-2h-2V6a4 4 0 00-4-4zm-2 7V6a2 2 0 114 0v3h-4z"
              />
            </svg>
            <h1 id="login-heading" className="title">
              Đăng nhập
            </h1>
          </div>

          <form onSubmit={handleLogin} className="login-glass-form" noValidate>
            <label className="login-glass-field">
              <span className="login-label-text"></span>
              <input
                id="username"
                name="username"
                type="text"
                autoComplete="username"
                placeholder="Nhập tên đăng nhập"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={isAppLoginLoading}
                required
              />
            </label>

            <label className="login-glass-field">
              <div className="login-pw-wrap">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={isAppLoginLoading}
                  required
                />
                <button
                  type="button"
                  id="togglePw"
                  className="login-toggle-pw"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  disabled={isAppLoginLoading}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </label>

            {error && <div className="login-error-msg">{error}</div>}

            <div className="login-glass-row">
              <a href="#" className="login-forgot" onClick={(e) => e.preventDefault()}>
                Quên mật khẩu?
              </a>
            </div>

            <button
              type="submit"
              className="login-glass-btn"
              disabled={isAppLoginLoading}
            >
              {isAppLoginLoading ? "Đang đăng nhập..." : "Đăng nhập"}
            </button>

            <p className="login-footer-note">
              Hệ thống bán hàng <a href="#" className="login-link">Pos</a>
            </p>
          </form>
        </section>
      </div>
    </>
  );
}

export default OrderLoginPage;
